// The one place the "we refused to split this waterfall" copy lives.
//
// A recipient fan-out is refused when the share set is not a share set — a
// seller on the pool roster is unpayable, or a priority's shares do not total
// 100%. The engines fail closed on that, because the alternative is paying one
// party's share to another with every downstream total still reconciling.
//
// A PREVIEW, though, is exactly where an operator is standing when they find
// out, so previews catch the refusal and hand the reason here instead of
// letting it escape as an error banner. The reason string is written server-
// side for a human and names both the record and the remedy; this component
// wraps it in the framing the operator needs around it — that nothing was
// recorded, what is still trustworthy on the page, and what to do next.
//
// Rendered by the investor-closing, VFI-inflow and financial-closing wizards.
// Each one must ALSO disable its confirm: executing in this state raises the
// same refusal, so an enabled button is a promise the server will not keep.

export interface WaterfallBlockedNoticeProps {
  /** The server's operator-facing reason. Rendered verbatim. */
  reason: string;
  /** What cannot proceed, as it appears mid-sentence — "closing", "inflow". */
  subject: string;
  /** What on this page is still trustworthy despite the refusal. */
  scopeNote: string;
}

export function WaterfallBlockedNotice({
  reason,
  subject,
  scopeNote,
}: WaterfallBlockedNoticeProps) {
  return (
    <div
      role="alert"
      className="rounded-md border border-status-error/30 bg-status-error/10 p-space-3 text-small"
    >
      <p className="m-0 font-semibold text-onyx">
        This {subject} cannot be run yet.
      </p>
      <p className="mt-space-2 m-0">{reason}</p>
      <p className="mt-space-2 m-0 text-gray-mid">
        Nothing has been recorded. {scopeNote} Correct the record, then run this
        preview again.
      </p>
    </div>
  );
}
